<button class="btn" (click)="scrollToElement('content')">{{'ui.button.info'|translate}}</button>